<template>
  <div>
    <Head :title="form.nama" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/persyaratan-pertanggungjawabans">Persyaratan Pertanggung Jawaban</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ persyaratan.nama }}
    </h1>
    <div class="w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.nama" :error="form.errors.nama" class="pb-8 pr-6 w-full" label="Nama Persyaratan" />

          <div class="pb-8 pr-6 w-full lg:w-1/3 flex">
            <input id="is_required" v-model="form.is_required" type="checkbox" class="mr-2" />
            <label for="is_required" class="flex flex-row items-center cursor-pointer">
              Wajib
            </label>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link class="btn-red" href="/persyaratan-pertanggungjawabans">
            <font-awesome-icon class="mr-2" icon="fas fa-arrow-left" />Kembali
          </Link>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    persyaratan: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nama: this.persyaratan.nama,
        is_required: this.persyaratan.is_required,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/persyaratan-pertanggungjawabans/${this.persyaratan.id}`)
    },
  },
}
</script>
